import React, { useEffect, useState } from "react";

import { Button, Modal, Form, Input, Dimmer, Loader } from "semantic-ui-react";
import { classNames } from "@react-pdf-viewer/core";
import { axiosInstance } from "../../fetcher";
import { APP_SETTINGS } from "../../env";

const style = {
  dropDownL: {
    padding: "8px",
    fontSize: "14px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
  },
};

const GlossaryText = (props) => {
  const [editModalState, setEditModalState] = useState(false);

  const [sourceValueEdit, setSourceValueEdit] = useState(
    props.selectedRowsPrivate[0]?.Term
  );
  const [translation, setTranslation] = useState();
  const [editRecordsLoader, setEditRecordsLoader] = useState(false);
  const [languageList, setLanguageList] = useState([]);
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("");

  const [engagementName, setEngagementName] = useState();
  
  const currentDomain = window.location.hostname.split(".")[1];

  let endpointToUse;

  if (currentDomain === "azurewebsites") {
    endpointToUse = new URL(APP_SETTINGS.public_endpoint).origin;
  } else {
    endpointToUse = new URL(APP_SETTINGS.private_endpoint).origin;
  }
  const currentUrl = endpointToUse;
  // console.log("engagementName Name:", engagementName);
  
  useEffect(() => {
    fetchSupportedLanguages();
    checkparam();
  }, []);

  const checkparam = async () => {
    try {
      const responseEngagementName = await axiosInstance.post(
              "/engagements/get_engagements_name", { url: currentUrl }
            );
      
            
      
      setEngagementName(responseEngagementName.data.engagement_name);
      // console.log("OS Param value is - ", responseEngagementName.data);
    } catch (error) {
      console.error("Error fetching engagement name:", error);
    }
  };

  const fetchSupportedLanguages = async () => {
    try {
      const response = await axiosInstance.get(
        "/glossary/get_supported_languages"
      );
      // Fix: Check the correct structure of the response data
      if (response.data && response.data.data && response.data.data.languages) {
        setLanguageList(response.data.data.languages);
      } else if (response.data && response.data.languages) {
        // Alternative structure that might be used
        setLanguageList(response.data.languages);
      } else {
        console.error("Language data not found in API response:", response.data);
      }
    } catch (error) {
      console.error("Error fetching supported languages:", error);
    }
  };

  const handleUpdate = async () => {
    if (translation) {
      const updatePayload = {
        input_data: {
          Id: props.selectedRowsPrivate[0].Id,
          Translation: translation,
          SourceLanguageOriginal: sourceLanguage,
          TargetLanguageOriginal: targetLanguage
        },
        engagementName: engagementName // Use the state variable instead of hardcoded value
      };

      try {
        setEditRecordsLoader(true);
        const response = await axiosInstance.post(`/glossary/update_record`, updatePayload);
        
        if (response.data) {
          props.fetchGlossaryData();
          setEditModalState(false);
          setEditRecordsLoader(false);
        }
      } catch (error) {
        console.error("Error updating record:", error);
        setEditRecordsLoader(false);
      }
    }
  };

  return (
    <div>
      <Modal
        style={{
          border: "1px black solid",
          position: "absolute",
          top: "17%",
          left: "25%",
          transform: "transform(-50%, -50%)",
          width: "700px",
          height: "auto",
        }}
        onClose={() => setEditModalState(false)}
        onOpen={() => {
          setEditModalState(true);
          setSourceValueEdit(props.selectedRowsPrivate[0].Term);
          setTranslation(props.selectedRowsPrivate[0].Translation);
          setSourceLanguage(
            props.selectedRowsPrivate[0].SourceLanguageOriginal
          );
          setTargetLanguage(
            props.selectedRowsPrivate[0].TargetLanguageOriginal
          );
        }}
        open={editModalState}
        trigger={
          <button
            type="button"
            className="btn btn-primary btn-md rounded-pill"
            style={{
              color: "white",
              margin: "11px",
              background:
                props.selectedRowsPrivate.length > 0 ? "#00e6e3" : "lightgray",
            }}
            disabled={props.selectedRowsPrivate.length !== 1}
          >
            {/* <Icon  name='edit'/> */}
            Edit Record
          </button>
        }
      >
        <Modal.Header>Edit Glossary Record</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>Source</label>
              <Input
                icon="language"
                iconPosition="left"
                placeholder="Source definition"
                error={sourceValueEdit === ""}
                value={props.selectedRowsPrivate[0]?.Term}
                disabled
              />
            </Form.Field>
            <Form.Field required>
              <label>Target</label>
              <Input
                icon="language"
                iconPosition="left"
                placeholder="Target definition"
                value={translation}
                error={translation === ""}
                onChange={(e) => setTranslation(e.target.value)}
              />
            </Form.Field>

            <Form.Field required>
              <div>
                <label htmlFor="sourceLanguage" style={{ marginRight: "10px" }}>
                  <b>Source Language </b>
                </label>
                <select
                  disabled
                  id="sourceLanguage"
                  name="sourceLanguage"
                  value={props.selectedRowsPrivate[0]?.SourceLanguageOriginal}
                  onChange={(e) => setSourceLanguage(e.target.value)}
                  className="dropdown-select"
                  style={style.dropDownL}
                >
                  {" "}
                  <option key="default" value="default">
                    {" "}
                    -- Select Source Language --{" "}
                  </option>
                  {languageList && languageList.length > 0 ? (
                    languageList
                      .filter((ele) => ele.languageCode !== "auto")
                      .sort((a, b) =>
                        a.languageName.localeCompare(b.languageName)
                      )
                      .map((language) => (
                        <option
                          key={language.languageCode}
                          value={language.languageCode}
                        >
                          {language.languageName}
                        </option>
                      ))
                  ) : (
                    <option value="" disabled>
                      Loading languages...
                    </option>
                  )}
                </select>
              </div>{" "}
            </Form.Field>
            <Form.Field required>
              <div>
                <label htmlFor="targetLanguage" style={{ marginRight: "10px" }}>
                  <b>Target Language </b>
                </label>
                <select
                  id="targetLanguage"
                  name="targetLanguage"
                  value={targetLanguage}
                  onChange={(e) => setTargetLanguage(e.target.value)}
                  className="dropdown-select"
                  style={style.dropDownL}
                >
                  {" "}
                  <option key="default" value="default">
                    {" "}
                    -- Select Target Language --{" "}
                  </option>
                  {languageList && languageList.length > 0 ? (
                    languageList
                      .filter((ele) => ele.languageCode !== "auto")
                      .sort((a, b) =>
                        a.languageName.localeCompare(b.languageName)
                      )
                      .map((language) => (
                        <option
                          key={language.languageCode}
                          value={language.languageCode}
                        >
                          {language.languageName}
                        </option>
                      ))
                  ) : (
                    <option value="" disabled>
                      Loading languages...
                    </option>
                  )}
                </select>
              </div>
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="black"
            onClick={() => {
              setEditModalState(false);
              setSourceLanguage("default");
              setTargetLanguage("default");
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={
              translation
                ? translation.replace(/\s/g, "") == ""
                  ? true
                  : false
                : false || targetLanguage == "default"
            }
            content="Save Changes"
            labelPosition="right"
            icon="save"
            onClick={handleUpdate}
            positive
          />
          <Dimmer active={editRecordsLoader} inverted>
            <Loader inline />
          </Dimmer>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default GlossaryText;